// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
    apiUrl: (<any>window)._env.backendUrl,
    domain: 'localhost',
    secretKey: 'a5vlIkj+btdUiXYhPtprPKudHv83RIhr8n3/0y8PYJCUflPCJL4YSHvbPZSnA3b5qdqv8U2L0BXVZhSU6ssiQg==',
    debug: false,
    hmr: false,
    NgxDatatableModule : '@swimlane/ngx-datatable'
};


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/environments/environment.ts